<form [formGroup]="formGroup" *ngIf="formGroup" class="edit_document_fileNameField mb-4">
  <div class="documentname_regex">
    <div *ngFor="let field of documentNumberForm; index as i">
      <div *ngIf="field.fieldType === 'Sequence'" style="width: 130px;">
        <app-input-filed [value]="formGroup.value?.[field._id]"
          [control]="$any(formGroup).controls[field._id]" placeholder="Sequence"></app-input-filed>
      </div>
      <div *ngIf="field.fieldType === 'RS'" style="width: 130px;">
        <app-input-filed [value]="formGroup.value?.[field._id]" [control]="$any(formGroup).controls[field._id]"
          [maxlength]="field.len" [minlength]="field.len" placeholder="String"></app-input-filed>
        <div *ngIf="formGroup.controls?.[field._id]?.errors?.['minlength']">
          <small class="text-danger">The Value of RS should be {{ field.len }}.</small>
        </div>
      </div>
      <div *ngIf="field.fieldType === 'YY'" style="width: 130px;">
        <app-input-filed [value]="formGroup.value?.[field._id]"
          [control]="$any(formGroup).controls[field._id]" placeholder="{{field.label}}"
          maxlength="2"></app-input-filed>
      </div>
      <div *ngIf="field.fieldType === 'YYYY'" style="width: 130px;">
        <app-input-filed [value]="formGroup.value?.[field._id]"
          [control]="$any(formGroup).controls[field._id]" placeholder="{{field.label}}"
          maxlength="4" [max]="prasentYear"></app-input-filed>
        <div *ngIf="formGroup.controls?.[field._id]?.errors?.['max']">
          <small class="text-danger">The Value of {{field.fieldType}} should not be greater than {{ prasentYear }}.</small>
        </div>
      </div>
      <div *ngIf="field.fieldType === 'Static'" style="width: 130px;">
        <app-input-filed [readonly]="true" [value]="field.value"
          [control]="$any(formGroup).controls[field._id]" placeholder="{{field.label}}"></app-input-filed>
      </div>
      <div *ngIf="field.fieldType === 'DDMMYYYY'" class="filterOffcanvas__calenderbody">
        <div class="filterOffcanvas__calenderWrapper">
          <input type="date" [max]="ddmmyyyyy" [ngModel] ="(field.value?field.value:ddmmyyyyy) | date:'yyyy-MM-dd'" placeholder="DDMMYYYY"
            class="custom-date-input form-control filterOffcanvas__inputlabel"
            [formControl]="$any(formGroup).controls[field._id]" style="border: none" />
        </div>
      </div>
      <div *ngIf="field.fieldType === 'DDMMYY'" class="filterOffcanvas__calenderbody">
        <div class="filterOffcanvas__calenderWrapper">
          <input type="date" [max]="ddmmyy" [ngModel] ="(field.value?field.value:ddmmyy) | date:'yyyy-MM-dd'" placeholder="DDMMYY"
            class="custom-date-input form-control filterOffcanvas__inputlabel"
            [formControl]="$any(formGroup).controls[field._id]" style="border: none" />
        </div>
      </div>
      <div *ngIf="field.fieldType === 'MM'" style="margin-top: -17px;">
        <div class="documentType__dropdown">
          <select class="docType__dropdownOptions_mm" [formControl]="$any(formGroup).controls[field._id]">
            <option value="MM" disabled selected>MM</option>
            <ng-container *ngFor="let item of daysMonths; let i=index">
              <option *ngIf="i<12" [ngValue]="item">
                {{ item }}
              </option>
            </ng-container>
          </select>
        </div>
      </div>
      <div *ngIf="field.fieldType === 'DD'" style="margin-top: -17px;">
        <div class="documentType__dropdown">
          <select class="docType__dropdownOptions_mm" [formControl]="$any(formGroup).controls[field._id]">
            <option value="DD" disabled selected>DD</option>
            <option *ngFor="let item of daysMonths" [ngValue]="item">
              {{ item }}
            </option>
          </select>
        </div>
      </div>
      <div *ngIf="field.fieldType === 'Numeric'" style="width: 130px;">
        <app-input-filed [value]="formGroup.value?.[field._id]"
          [control]="$any(formGroup).controls[field._id]" placeholder="{{field.label}}"
          type="number"></app-input-filed>
        <div *ngIf="formGroup.controls?.[field._id]?.invalid &&
                                  (formGroup.controls?.[field._id]?.dirty ||
                                  formGroup.controls?.[field._id]?.touched)">
        </div>
      </div>
    </div>
  </div>
  <div class="barcode-message">
    <small class="text-danger">{{showErrorMessage()}}</small>
  </div>
  <div *ngIf="metaData?.length">
    <div *ngFor="let field of metaData" class="mt-3">
      <div *ngIf="field.fieldType === 'Text'">
        <app-input-filed [value]="formGroup.value?.[field._id]" label="{{field.label}}"
          [control]="$any(formGroup).controls[field._id]" starIcon="{{field.validateRequire?'*':''}}"
          placeholder="{{field.label}}"></app-input-filed>
        <div *ngIf="formGroup.controls?.[field._id]?.invalid &&
                                  (formGroup.controls?.[field._id]?.dirty ||
                                  formGroup.controls?.[field._id]?.touched)">
          <div *ngIf="formGroup.controls?.[field._id]?.errors?.['required']">
            <small class="text-danger">{{field.label}} is required</small>
            <small class="text-danger">{{field.len}} is required</small>
          </div>
        </div>
      </div>
      <div *ngIf="field.fieldType === 'TextArea'">
        <app-description-field [DescriptionData]="field.label" class="pt-3"
          [control]="$any(formGroup).controls[field._id]" starIcon="{{field.validateRequire?'*':''}}"
          placeholder="{{field.label}}"></app-description-field>
        <div *ngIf="formGroup.controls?.[field._id]?.invalid &&
                        (formGroup.controls?.[field._id]?.dirty ||
                        formGroup.controls?.[field._id]?.touched)">
          <div *ngIf="formGroup.controls?.[field._id]?.errors?.['required']">
            <small class="text-danger">{{ field.label }} is required.</small>
          </div>
        </div>
      </div>
      <div *ngIf="field.fieldType === 'Radio'">
        <section class="editDocument__radioContainer">
          <p class="editDocument__text1">{{ field.label }} <span *ngIf="field.validateRequire"
              class="spmred">*</span></p>
          <div class="editDocument__radioButtons">
            <app-radiobutton *ngFor="let fieldVaue of field.fieldValues"
              (checked)="handleDocumentTypeChange.emit({ value: fieldVaue, id: field._id })" value="{{fieldVaue}}"
              radioText="{{fieldVaue}}"
              [defaultCheck]="selectedFile?._id?getradioValue(fieldVaue, selectedFile?.metaData, field._id):fieldVaue === selectedFile?.metaData?.[field._id]">
            </app-radiobutton>
          </div>
        </section>
      </div>
      <div *ngIf="field.fieldType === 'CheckBox'">
        <p class="editDocument__text1">{{ field.label }}</p>
        <div class="toggle-button-text" *ngFor="let fieldvalue of field.fieldValues">
          <div>
            <app-checkbox class="editDocument__checkbox" className="labelWidth"
              checkboxStatus="{{fieldvalue === selectedFile?.metaData?.[field._id]}}"
              (checked)="handleDocumentTypeChange.emit({ value: fieldvalue, id: field._id })"
              checkBoxName={{fieldvalue}}></app-checkbox>
          </div>
        </div>
      </div>
      <div *ngIf="field.fieldType === 'Number'">
        <app-input-filed [value]="formGroup.value?.[field._id]" label="{{field.label}}"
          [control]="$any(formGroup).controls[field._id]" type="number"
          starIcon="{{field.validateRequire?'*':''}}" placeholder="{{field.label}}"></app-input-filed>
        <div *ngIf="formGroup.controls?.[field._id]?.invalid &&
                        (formGroup.controls?.[field._id]?.dirty ||
                        formGroup.controls?.[field._id]?.touched)">
          <div *ngIf="formGroup.controls?.[field._id]?.errors?.['required']">
            <small class="text-danger">{{ field.label }} is required.</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
